var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transfer',{attrs:{"data":_vm.data,"target-keys":_vm.targetKeys,"render-format":_vm.render,"list-style":_vm.listStyle},on:{"on-change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }